<script>
import TheClientLegacyBullhornDataContainer from '@/components/client/bullhorn/the-client-legacy-bullhorn-data-container.vue'
import Layout from '@layouts/main.vue'

export default {
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [
        { name: 'description', content: 'The Client Legacy Bullhorn page.' },
      ],
    }
  },
  components: { Layout, TheClientLegacyBullhornDataContainer },
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },
  computed: {
    parsedClientId() {
      return parseInt(this.clientId) || -1
    },
  },
}
</script>

<template>
  <Layout>
    <TheClientLegacyBullhornDataContainer :client-id="parsedClientId" />
  </Layout>
</template>
